var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4075 7.1575C6.2175 7.1575 6.0275 7.0875 5.8775 6.9375L0.2175 1.2775C-0.0725 0.987499 -0.0725 0.5075 0.2175 0.2175C0.5075 -0.0725 0.987499 -0.0725 1.2775 0.2175L6.9375 5.8775C7.2275 6.1675 7.2275 6.6475 6.9375 6.9375C6.7875 7.0875 6.5975 7.1575 6.4075 7.1575Z",
    fill: "#5B5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.7475 7.1575C0.5575 7.1575 0.3675 7.0875 0.2175 6.9375C-0.0725 6.6475 -0.0725 6.1675 0.2175 5.8775L5.8775 0.2175C6.1675 -0.0725 6.6475 -0.0725 6.9375 0.2175C7.2275 0.5075 7.2275 0.987499 6.9375 1.2775L1.2775 6.9375C1.1375 7.0875 0.9375 7.1575 0.7475 7.1575Z",
    fill: "#5B5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.55f0a20a84a3e243070c38076170a686.svg";
export { ForwardRef as ReactComponent };